import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireFeatureGate } from '~/utils/guards';

const ScheduledDeliveryWizardPage = lazy(
  () => import('~/features/content-enrichment/pages/scheduled-delivery-wizard-page'),
);

/**
 * Pre-delivery wizard for the Google Ads enrichment funnel's "Confirm &
 * Publish" action. A trailing-underscore leaf route (`$batchId_`, not
 * `$batchId`) so it escapes the sibling `$batchId.tsx` layout route's
 * `ContentEnrichmentLayout` chrome (funnel stepper + agent panel + sticky
 * footer) — mirroring `catalog-operations/$batchId_/deliver.tsx`'s identical
 * escape from that layout's own batch-detail chrome. The wizard renders its
 * own 3-step Stepper instead.
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId_/deliver',
)({
  beforeLoad: requireFeatureGate('delivery-wizard'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ScheduledDeliveryWizardPage />
    </Suspense>
  ),
});
